const getStyleNonce = (): string | undefined => document
    .querySelector<HTMLMetaElement>('meta[name="csp-style-nonce"]')
    ?.content || undefined;

const installShim = (nonce: string): void => {
    const nativeCreateElement = document.createElement.bind(document);

    document.createElement = function createElement(
        this: Document,
        tagName: string,
        options?: ElementCreationOptions,
    ): HTMLElement {
        const element = nativeCreateElement(tagName, options);
        if (typeof tagName === 'string' && tagName.toLowerCase() === 'style') {
            element.setAttribute('nonce', nonce);
            (element as HTMLStyleElement).nonce = nonce;
        }
        return element;
    } as typeof document.createElement;
};

const nonce = getStyleNonce();
if (nonce) {
    installShim(nonce);
}
